import { forwardRef } from 'react'

const Select = forwardRef(({ 
  children, 
  className = '', 
  error, 
  ...props 
}, ref) => {
  const baseClasses = 'block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 sm:text-sm'
  const errorClasses = error ? 'border-red-300 focus:ring-red-500 focus:border-red-500' : ''
  const combinedClasses = `${baseClasses} ${errorClasses} ${className}`.trim()

  return (
    <div>
      <select
        ref={ref}
        className={combinedClasses}
        {...props}
      >
        {children}
      </select>
      {error && (
        <p className="mt-1 text-sm text-red-600">
          {error}
        </p>
      )}
    </div>
  )
})

Select.displayName = 'Select'

export default Select



